import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { FaTwitter, FaArrowRight } from "react-icons/fa"

const Picture = ({ imgData, author, quote }) => {
  const capitalizedAuthor = author.slice(0, 1).toUpperCase() + author.slice(1)
  const categories = ["jhope", "jimin", "jin", "jungkook", "rm", "suga", "v"]
  const category = categories[Math.floor(Math.random() * 7)]
  const quoteNumber = Math.floor(Math.random() * 5 + 1)

  return (
    <PictureWrapper>
      <Img fluid={imgData} style={{ width: "100%" }} />
      <Icons>
        <IconWrapper
          href={`https://twitter.com/intent/tweet?hashtags=BTS&related=${author}&text=${quote}%20-${capitalizedAuthor}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitter className="icon" />
        </IconWrapper>
        <IconWrapper href="#">
          <Link
            to={`/${category}/${category + quoteNumber}`}
            className="gatsby-link"
          >
            <FaArrowRight className="icon" />
          </Link>
        </IconWrapper>{" "}
      </Icons>
    </PictureWrapper>
  )
}

export default Picture

const PictureWrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 576px) {
    flex: 1.5;
  }
`
const Icons = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
`

const IconWrapper = styled.a`
  width: 4rem;
  height: 3rem;
  background: var(--mainBlack);
  display: flex;
  justify-content: center;
  align-items: center;

  .gatsby-link {
    background: #444;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    width: 50%;
    height: 50%;
    fill: var(--mainWhite);
  }

  &:hover .icon {
    fill: var(--mainPink);
  }
`
